import React,{ useState, useEffect} from 'react';
import { useSelector, useDispatch} from 'react-redux';
import {Loader, Modal, Button } from 'rsuite';
import * as actionsAuth  from '../../../../../app/actions/auth/auth';
import { NuInsInputPasswordLabel, NuInsSelectGroupLabel,  NuInsInputNumLabel } from '../../elements/inputFieldsLabel';
import {Vector} from '../../svg/iconsSvg';
import countryCodes from '../../liabilityPolicy/common/countryCodes.json';

const countryCodesOptions = countryCodes.map((doc, i) => ({label: doc["COUNTRY_NAME"], value: doc["PHONE_CODE"], key: i+1, code: doc["COUNTRY_CODE"] , order: doc["VIEW_ORDER"]}))

const LoginComponent = ({open, onClose, submitText, children}) => {

    const dispatch = useDispatch();

    const auth = useSelector(state=>state.auth);

    const [loginData, setLoginData] = useState({password: null, countryCode: '359' , phoneNo: null});

    const [checkFields, setCheckFields] = useState({});

    const [showCredentialModal, setShowCredentialModal] = useState(false);

    const [loading, setLoading] = useState(false);

    const errorMsg = "Полето е задължително";

    useEffect(()=>{
        if(Object.keys(auth).includes('loginToken') && !auth?.loginToken) {
            setShowCredentialModal(true);
        } else if (auth?.loginToken) {
            onClose();
            
        }
    }, [auth, onClose]);

    useEffect(()=>{
        setCheckFields({});
        setLoginData({password: null, countryCode: '359' , phoneNo: null})
    }, [open]);

    const closeModal = () => {
        setShowCredentialModal(false);
    }

    const onChangeHandler = (field, data) =>  {
        if(field === 'countryCode' && data) {
            data = data.substring(1);
        }

        setLoginData({ ...loginData, [field]:data });
    }

    const onBlurHandler = (field) =>  {
       setCheckFields({...checkFields, [field]: true});
    }

    const checkForError = (field, type, allFields) =>  {
        
        switch (type) {
            case 'password':
                return (checkFields[field] || allFields) && (!loginData[field]);
            case 'phoneNo':
                return (checkFields[field] || allFields) && (!loginData[field]);
            default:
                return (checkFields[field] || allFields) && !loginData[field];
        }
    }

    const generateErrorMsg = (field, type) => {
        switch (type) {
            case 'password':
                if(!loginData[field]) return errorMsg;
                break
            case 'phoneNo':
                if(!loginData[field]) return errorMsg;
                break
            default:
                return errorMsg;
        }
    }

    const validateAll = () => {
        if(loginData.password && loginData.phoneNo) return true;

        return false;
    }

    const submitHandler = async () => {

        setCheckFields({password: true, phoneNo: true});

        if(validateAll()) {
            const userName = `${loginData.countryCode}${loginData.phoneNo}`;
            setLoading(true)
            await dispatch(actionsAuth.getLoginToken(userName, loginData.password));
        //for test only
          //  await dispatch(actionsAuth.getLoginToken('359888792833', 'password'));
            setLoading(false)
 //return getLoginToken('359888792833', 'password');
        }
    }


    return (
        <>
            <div className="user-login" >
                <div style={{textAlign: 'center', marginBottom: '20px'}}> <Vector /></div>
                
                <div className="address-telephone-container">          
                    <NuInsSelectGroupLabel onChange={(data)=>onChangeHandler('countryCode', data)}
                        value={'+' + loginData.countryCode}
                        placeholder={"Телефон"}
                        options={countryCodesOptions} 
                        ></NuInsSelectGroupLabel>
                        <div style={{marginLeft:'4px'}}>
                            <NuInsInputNumLabel onChange={(data)=>onChangeHandler('phoneNo', data)} onBlur={()=>onBlurHandler('phoneNo')}
                                                validationType={"vin"} slice={9} 
                                                value={loginData.phoneNo}
                                                placeholder={" "}                                  
                                                error= {checkForError('phoneNo', 'phoneNo')}
                                                errorMsg={generateErrorMsg('phoneNo', 'phoneNo')}
                                                /> 
                    </div>       
                </div>  
                <NuInsInputPasswordLabel onChange={(data)=>onChangeHandler('password', data)} onBlur={()=>onBlurHandler('password')}
                            slice={30}                            
                            placeholder={"Парола"} 
                            value={loginData.password} 
                            error={checkForError('password', 'password')} 
                            errorMsg={generateErrorMsg('password', 'password')}
                            styles={{marginBottom: '78px'}}
                            />
        
                {children}
                <button className="nuIns-btn nuIns-btn-mxd nuIns-btn-main" type="submit" 
                        onClick={submitHandler} >{submitText}</button>
                
                {loading ? <Loader backdrop center size="lg" speed="slow" /> : null }
            </div>

            {/* Modal for wrong credential */}
            <Modal size="xs" show={showCredentialModal} className="nuins-ok-modal" onHide={() => closeModal()}>
                <Modal.Body >
                    <p className="no-reg-data" >Грешен телефонен номер или парола</p>    
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={() => closeModal()} >OK</Button>
                </Modal.Footer>
            </Modal>
        </>
    )

}

export default LoginComponent;